import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useContext, useEffect, useState } from 'react';
import SocketContext from '../../contexts/SocketContext';
import DialogActions from '@mui/material/DialogActions/DialogActions';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AlertResponse } from '../../socket_messages/Alert';
import { useTranslation } from '../../contexts/LanguageContext';

export default function Alert() {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const { SocketState } = useContext(SocketContext);
    const navigate = useNavigate();
    const { t } = useTranslation();

    let hasSubscribe = false;

    const subscribe = () => {
        if (!hasSubscribe) {
            SocketState.socket?.on(AlertResponse.Message, (args: AlertResponse) => {
                setErrorMessage(args.message);
                setOpen(true);
            });
            hasSubscribe = true;
        }
    };

    const handleClose = () => {
        setOpen(false);
        navigate('/');
    };

    subscribe();

    return (
        <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogContent>
                <DialogContent dividers>
                    <Typography gutterBottom>{t('fatalError')}</Typography>
                    <Typography sx={{ marginBottom: 4 }}>{t('sendError')} </Typography>
                    <Typography sx={{ marginBottom: 4 }}>{errorMessage}</Typography>
                    <Typography sx={{ marginBottom: 4 }}>_____________________________</Typography>
                    <Typography sx={{ marginBottom: 2 }}>{t('reloadGame')}</Typography>
                </DialogContent>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('backToHome')}</Button>
            </DialogActions>
        </Dialog>
    );
}
